import { detectFieldType } from './helpers/detectFieldType';
import { SelectField } from './components/SelectField';
import { TextField } from './components/TextField';
import type { TextInputFieldType } from './types';
import type { FieldProps } from '@rjsf/utils';
import type { ComponentType } from 'react';
import { useMemo } from 'react';
import type { RJSFInputAdapter } from '@/components/organisms/DynamicForm/components/RSJVInputAdaters/types';

export const TextInputAdapter: RJSFInputAdapter<string, any> = props => {
  const InputComponent = useMemo(() => {
    const fieldsMap: Record<
      TextInputFieldType,
      React.ComponentType<FieldProps<string>> | ComponentType<FieldProps<string | number>>
    > = {
      select: SelectField,
      text: TextField,
    };

    const fieldType = detectFieldType(props);

    return fieldsMap[fieldType];
  }, [props]);

  return <InputComponent {...props} />;
};
